// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.product-images-form {
    width:80%;
    max-width: 600px;
    margin: 0 auto;
    /* Center the form */
    padding: 20px;
    border: 1px solid #ddd;
    border-radius: 8px;
    background-color: #f9f9f9;
    box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
}

.product-images-form h2 {
    text-align: center;
    margin-bottom: 20px;
    color: #333;
    font-size: 1.5rem;
}

.product-images-form label {
    display: block;
    font-weight: bold;
    margin-bottom: 5px;
    color: #555;
}

.product-images-form input[type="text"],
.product-images-form input[type="file"] {
    width: 90%;
    padding: 10px;
    margin-bottom: 15px;
    border: 1px solid #ccc;
    border-radius: 4px;
    font-size: 1rem;
    background-color: #fff;
    transition: border-color 0.3s ease;
}

.product-images-form input[type="text"]:focus,
.product-images-form input[type="file"]:focus {
    border-color: #007bff;
    outline: none;
}

.product-images-form .product-images-btn {
    width: 100%;
    padding: 12px 20px;
    font-size: 1rem;
    font-weight: bold;
    color: #fff;
    background-color: #007bff;
    border: none;
    border-radius: 4px;
    cursor: pointer;
    transition: background-color 0.3s ease;
}

.product-images-form .product-images-btn:hover {
    background-color: #0056b3;
}

.product-images-form .form-group {
    margin-bottom: 15px;
}

.product-images-form .file-label {
    margin-bottom: 10px;
    color: #888;
    font-size: 0.9rem;
}

.product-images-form .error-message {
    color: red;
    font-size: 0.9rem;
    margin-top: -10px;
    margin-bottom: 10px;
}

.product-images-form .preview {
    margin-top: 15px;
    display: flex;
    gap: 10px;
}

.product-images-form .preview img {
    width: 80px;
    height: 80px;
    border: 1px solid #ccc;
    border-radius: 4px;
    object-fit: cover;
}`, "",{"version":3,"sources":["webpack://./src/Styles/ProductImagesForm.css"],"names":[],"mappings":"AAAA;IACI,SAAS;IACT,gBAAgB;IAChB,cAAc;IACd,oBAAoB;IACpB,aAAa;IACb,sBAAsB;IACtB,kBAAkB;IAClB,yBAAyB;IACzB,wCAAwC;AAC5C;;AAEA;IACI,kBAAkB;IAClB,mBAAmB;IACnB,WAAW;IACX,iBAAiB;AACrB;;AAEA;IACI,cAAc;IACd,iBAAiB;IACjB,kBAAkB;IAClB,WAAW;AACf;;AAEA;;IAEI,UAAU;IACV,aAAa;IACb,mBAAmB;IACnB,sBAAsB;IACtB,kBAAkB;IAClB,eAAe;IACf,sBAAsB;IACtB,kCAAkC;AACtC;;AAEA;;IAEI,qBAAqB;IACrB,aAAa;AACjB;;AAEA;IACI,WAAW;IACX,kBAAkB;IAClB,eAAe;IACf,iBAAiB;IACjB,WAAW;IACX,yBAAyB;IACzB,YAAY;IACZ,kBAAkB;IAClB,eAAe;IACf,sCAAsC;AAC1C;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,mBAAmB;IACnB,WAAW;IACX,iBAAiB;AACrB;;AAEA;IACI,UAAU;IACV,iBAAiB;IACjB,iBAAiB;IACjB,mBAAmB;AACvB;;AAEA;IACI,gBAAgB;IAChB,aAAa;IACb,SAAS;AACb;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,sBAAsB;IACtB,kBAAkB;IAClB,iBAAiB;AACrB","sourcesContent":[".product-images-form {\n    width:80%;\n    max-width: 600px;\n    margin: 0 auto;\n    /* Center the form */\n    padding: 20px;\n    border: 1px solid #ddd;\n    border-radius: 8px;\n    background-color: #f9f9f9;\n    box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);\n}\n\n.product-images-form h2 {\n    text-align: center;\n    margin-bottom: 20px;\n    color: #333;\n    font-size: 1.5rem;\n}\n\n.product-images-form label {\n    display: block;\n    font-weight: bold;\n    margin-bottom: 5px;\n    color: #555;\n}\n\n.product-images-form input[type=\"text\"],\n.product-images-form input[type=\"file\"] {\n    width: 90%;\n    padding: 10px;\n    margin-bottom: 15px;\n    border: 1px solid #ccc;\n    border-radius: 4px;\n    font-size: 1rem;\n    background-color: #fff;\n    transition: border-color 0.3s ease;\n}\n\n.product-images-form input[type=\"text\"]:focus,\n.product-images-form input[type=\"file\"]:focus {\n    border-color: #007bff;\n    outline: none;\n}\n\n.product-images-form .product-images-btn {\n    width: 100%;\n    padding: 12px 20px;\n    font-size: 1rem;\n    font-weight: bold;\n    color: #fff;\n    background-color: #007bff;\n    border: none;\n    border-radius: 4px;\n    cursor: pointer;\n    transition: background-color 0.3s ease;\n}\n\n.product-images-form .product-images-btn:hover {\n    background-color: #0056b3;\n}\n\n.product-images-form .form-group {\n    margin-bottom: 15px;\n}\n\n.product-images-form .file-label {\n    margin-bottom: 10px;\n    color: #888;\n    font-size: 0.9rem;\n}\n\n.product-images-form .error-message {\n    color: red;\n    font-size: 0.9rem;\n    margin-top: -10px;\n    margin-bottom: 10px;\n}\n\n.product-images-form .preview {\n    margin-top: 15px;\n    display: flex;\n    gap: 10px;\n}\n\n.product-images-form .preview img {\n    width: 80px;\n    height: 80px;\n    border: 1px solid #ccc;\n    border-radius: 4px;\n    object-fit: cover;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
